import React from 'react';

export function isHTMLNode(o) {
  return typeof Node === 'object'
    ? o instanceof Node
    : o && typeof o === 'object' && typeof o.nodeType === 'number' && typeof o.nodeName === 'string';
}

export function isHTMLElement(o) {
  return typeof HTMLElement === 'object'
    ? o instanceof HTMLElement //DOM2
    : o && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string';
}

export function notHTML(o) {
  return !(isHTMLElement(o) || isHTMLNode(o) || React.isValidElement(o));
}
